import type { ReactNode } from "react";

type NotAuthorizedStateProps = {
  title?: string;
  message?: ReactNode;
};

export function NotAuthorizedState({
  title = "Not Authorized",
  message = "You do not have permission to access this resource.",
}: NotAuthorizedStateProps) {
  return (
    <section className="events-page">
      <h1 className="events-page__title">{title}</h1>
      <p className="events-page__subtitle">{message}</p>
    </section>
  );
}
